/**
 * Domaine 2 du MLD v5.0 — instruction et délivrance.
 * Source : `db/migrations/001_init_schema.sql`.
 */
import { valeurs } from './enumeration.js';
// -----------------------------------------------------------------------------
// DEMANDE
// -----------------------------------------------------------------------------
/** `DEMANDE.nature_demande`. */
export const NATURE_DEMANDE = {
    NOUVELLE: 'nouvelle',
    RENOUVELLEMENT: 'renouvellement',
    MODIFICATION: 'modification',
};
export const NATURES_DEMANDE = valeurs(NATURE_DEMANDE);
/** `DEMANDE.statut` — états successifs du dossier dans le circuit. */
export const STATUT_DEMANDE = {
    SOUMISE: 'soumise',
    EN_INSTRUCTION: 'en_instruction',
    PRET_SIGNATURE: 'pret_signature',
    SIGNEE: 'signee',
    REJETEE: 'rejetee',
};
export const STATUTS_DEMANDE = valeurs(STATUT_DEMANDE);
// -----------------------------------------------------------------------------
// INSTRUCTION
// -----------------------------------------------------------------------------
/** `INSTRUCTION.statut_instruction` — avis d'une administration sur un dossier. */
export const STATUT_INSTRUCTION = {
    EN_ATTENTE: 'en_attente',
    VALIDE: 'valide',
    REJETE: 'rejete',
};
export const STATUTS_INSTRUCTION = valeurs(STATUT_INSTRUCTION);
// -----------------------------------------------------------------------------
// LICENCE / PERMIS
// -----------------------------------------------------------------------------
/**
 * `LICENCE.statut`. Attention : le permis emploie des formes masculines
 * (`actif`, `suspendu`…) là où la licence emploie le féminin. Les deux jeux ne
 * sont pas interchangeables — c'est bien deux `CHECK` distincts en base.
 */
export const STATUT_LICENCE = {
    ACTIVE: 'active',
    SUSPENDUE: 'suspendue',
    ANNULEE: 'annulee',
    EXPIREE: 'expiree',
};
export const STATUTS_LICENCE = valeurs(STATUT_LICENCE);
/** `PERMIS.statut`. */
export const STATUT_PERMIS = {
    ACTIF: 'actif',
    SUSPENDU: 'suspendu',
    ANNULE: 'annule',
    EXPIRE: 'expire',
};
export const STATUTS_PERMIS = valeurs(STATUT_PERMIS);
// -----------------------------------------------------------------------------
// DOCUMENT_DELIVRE
// -----------------------------------------------------------------------------
/** `DOCUMENT_DELIVRE.type_document` — documents secondaires du circuit. */
export const TYPE_DOCUMENT_DELIVRE = {
    AGREMENT_SANITAIRE: 'agrement_sanitaire',
    FICHE_VISITE: 'fiche_visite',
    ATTEST_JOURNAL: 'attest_journal',
    AUTORISATION_EMBARQUEMENT: 'autorisation_embarquement',
    JOURNAL_PECHE: 'journal_peche',
    CERTIFICAT_ENREGISTREMENT: 'certificat_enregistrement',
    ATTESTATION_INN: 'attestation_inn',
    AUTRE: 'autre',
};
export const TYPES_DOCUMENT_DELIVRE = valeurs(TYPE_DOCUMENT_DELIVRE);
/** `DOCUMENT_DELIVRE.statut`. */
export const STATUT_DOCUMENT_DELIVRE = {
    VALIDE: 'valide',
    EXPIRE: 'expire',
    ANNULE: 'annule',
};
export const STATUTS_DOCUMENT_DELIVRE = valeurs(STATUT_DOCUMENT_DELIVRE);
//# sourceMappingURL=instruction.js.map